<script lang="ts">
  import { page } from '$app/stores';
  import { isProbablyMobile } from '../client/device.ts';
  import { getVar } from '../client/util.ts';
  // import { type IconType } from './Icon.svelte';
  import { Button, Icon, Outlined } from './index.ts';
  import { QRCode } from './qr_code.ts';

  export let icon: string;
  export let install: () => void;
  export let version: string | undefined = undefined;
  let isMobile = isProbablyMobile();
  const dark = getVar('--millies-dp');
  // TODO: Something like the pocket app with the spinning circle.

  const myth = false;
</script>

<div
  class="text-script text-xl text-m-bc bg-m-lv grow text-center min-w-full flex flex-col items-center relative pt-4 gap-1">
  <!-- <div class="min-w-full h-2 bg-gradient-to-t from-m-lv" /> -->
  <!-- <img class="w-full max-w-80 pt-8" src={MilliesLogo} />
  <Outlined
    class="inline-block font-bold text-m-dp text-5xl -mt-4 px-1"
    --outline-color="var(--millies-bc)">SWEET READS</Outlined> -->

  <div class="font-narrow font-medium text-center p-2">
    <div class="max-w-md mx-auto">
      <div class="inline-block mt-2">
        <!-- <img style="w-0 min-w-full" src={TODOLogo} /> -->
        <Outlined class="font-bold text-m-dp text-5xl -mt-4 px-1" --outline-color="white"
          >TODO REPLACE</Outlined>
      </div>
    </div>
  </div>

  <!-- <Icon size={48} {icon} class="ml-12 -mb-8" /> -->
  {#if myth}
    <Outlined class="text-3xl text-m-dp font-narrow font-bold" --outline-color="var(--millies-bc)"
      >The <span class="text-m-mc">App</span>, the <span class="text-m-mc">Myth</span>, the
      <span class="text-m-mc">Legend</span>.</Outlined>
    <Outlined class="text-xl text-m-dp font-narrow font-bold" --outline-color="var(--millies-bc)"
      >(<span class="italic">the <span class="text-m-cb">Beta</span></span>)</Outlined>
  {:else}
    <div class="mb-6 font-halis">Chad said he needed a nap, and then this happened…</div>
    <Outlined class="text-3xl text-m-dp font-narrow font-bold" --outline-color="var(--millies-bc)"
      >We proudly present</Outlined>
    <Outlined --outline-color="white" class="text-5xl my-2 text-m-dp font-funkydori font-bold"
      ><span class="text-m-dp">Millie's</span>: <span class="text-m-lp">An App</span></Outlined>
    <Outlined
      class="text-3xl text-m-dp font-funkydori font-bold"
      --outline-color="var(--millies-bc)"
      >(<span class="mx-2">in <span class="text-m-cb">Beta</span></span>)</Outlined>
  {/if}
  <div class="flex flex-col items-center gap-4 py-4">
    {#if isMobile}
      <Button onclick={install} class="w-40 h-40 text-3xl block !rounded-3xl">
        <div class="relative mx-auto w-[5.5rem] h-[5.5rem] bg-white rounded-3xl">
          <Icon size={32} {icon} class="top-0 left-0 absolute" />
        </div>
        <div class="">Install</div>
      </Button>
    {:else}
      <div class="w-[66vw] flex flex-col items-center gap-3">
        <QRCode clazz="h-[66vw]" text={$page.url.toString()} {dark} />
        <div class="font-halis">
          Scan the <Icon icon="qr_code" class="relative top-[5%]" /> code on your phone to install.
        </div>
        <Button onclick={() => (isMobile = true)} class="mt-4" color={dark}
          >Actually, this&nbsp;<span class="font-black italic">is</span>&nbsp;my phone.</Button>
      </div>
    {/if}
  </div>
  <!-- <div class="min-w-full h-2 bg-gradient-to-b from-m-lv" /> -->
  {#if version}
    <div class="absolute right-0 bottom-0 text-xs text-m-bc pr-2 pb-1">Version: {version}</div>
  {/if}
</div>
